import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar.js";
import { Banner } from "./components/Banner.js";
import { About } from "./components/About.js";
import { Skills } from './components/Skills';
import { Experience } from './components/Experience';
import {Project } from './components/Project';
import { Contact } from './components/Contact';



function App() {
  return (
    <>
      <NavBar />
      <Banner />
      <About />
      <Skills />
      <Experience />
      <Project />
      <Contact />
    </>
  );
}

export default App;
